import { render, staticRenderFns } from "./CardAnalyticsPurchaser.vue?vue&type=template&id=5d7bb290&scoped=true"
import script from "./CardAnalyticsPurchaser.vue?vue&type=script&lang=js"
export * from "./CardAnalyticsPurchaser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7bb290",
  null
  
)

export default component.exports